/* eslint-disable no-restricted-imports, hh/comment-budget */
import { Dialog, DialogContent, DialogContentText, Button } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { noop } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import T from 'T'

import HHDialogActions from './HHDialogActions'
import HHDialogTitle from './HHDialogTitle'

const HHConfirmDialog = ({
  isOpen = false,
  DialogProps = {},
  showCloseIconButton = true,
  showCancelButton = true,
  CancelButtonProps = {},
  cancelButtonTitle = T.CANCEL,
  ConfirmButtonProps = {},
  confirmTitle = 'Are you sure?',
  confirmDescription,
  // A description carrying its own controls cannot render inside a <p>.
  descriptionComponent = 'p',
  // Neutral by default. It read 'Delete' for years, so any dialog that forgot the prop told the user it
  // was about to delete something — including acknowledgements and an archive.
  confirmButtonTitle = T.CONFIRM,
  onConfirm = noop,
  onClose = noop,
}) => {
  const theme = useTheme()

  return (
    <Dialog {...DialogProps} open={isOpen} onClose={onClose}>
      <HHDialogTitle showCloseIcon={showCloseIconButton} title={confirmTitle} onClose={onClose} />
      {confirmDescription && (
        <DialogContent>
          <DialogContentText component={descriptionComponent} sx={{ ...theme.typography.body1, color: theme.palette.text.primary }}>
            {confirmDescription}
          </DialogContentText>
        </DialogContent>
      )}
      <HHDialogActions>
        {showCancelButton && (
          <Button color="textSecondary" variant="text" onClick={onClose} {...CancelButtonProps}>
            {cancelButtonTitle}
          </Button>
        )}
        <Button color="error" variant="contained" onClick={onConfirm} {...ConfirmButtonProps}>
          {confirmButtonTitle}
        </Button>
      </HHDialogActions>
    </Dialog>
  )
}

HHConfirmDialog.propTypes = {
  isOpen: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  showCloseIconButton: PropTypes.bool,
  confirmTitle: PropTypes.string,
  confirmDescription: PropTypes.node,
  descriptionComponent: PropTypes.elementType,
  cancelButtonTitle: PropTypes.string,
  confirmButtonTitle: PropTypes.string,
  DialogProps: PropTypes.object,
  CancelButtonProps: PropTypes.object,
  ConfirmButtonProps: PropTypes.object,
  children: PropTypes.node,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
}

export default HHConfirmDialog
